













































































































































































































































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import {mapGetters} from "vuex";
import {orderBy} from "lodash";
import Game, {GameRef} from '@/model/Game';
import {Player} from "@/model/Player";
import { format } from "date-fns";
import {GameService} from "@/services/GameService";
import TimeUtils from "@/services/TimeUtils";

@Component({
  computed: {
    ...mapGetters({
      games: "games",
      gameResults: "championshipGames",
      scrims: "scrims"
    })
  }
})
export default class GameDetails extends Vue {

  get durationRound1() {
    if (this.game && this.game.gameRefs[0].endTime) {
      return TimeUtils.getReadableDiffTime(this.game.gameRefs[0].endTime - this.game.gameRefs[0].startTime);
    }
  }

  get durationRound2() {
    if (this.game && this.game.gameRefs[1].endTime) {
      return TimeUtils.getReadableDiffTime(this.game.gameRefs[1].endTime - this.game.gameRefs[1].startTime);
    }
  }

  get durationGame() {
    if (this.game && this.game.gameRefs[0].endTime) {
      const duration = (this.game.gameRefs[0].endTime - this.game.gameRefs[0].startTime) + (this.game.gameRefs[1].endTime - this.game.gameRefs[1].startTime);
      return TimeUtils.getReadableDiffTime(duration);
    }
  }

  get bankable() {
    return this.retrieveValue("globalRatio");
  }

  get deadliest() {
    return this.retrieveValue("totalKills");
  }

  get assistant() {
    return this.retrieveValue("totalAssists");
  }

  get unkillable() {
    if (this.game) {
      return orderBy(this.playersWithoutSpectators, ["totalDeaths"], ["asc"])[0];
    }
  }

  get scorer() {
    return this.retrieveValue("totalScore");
  }

  get targeted() {
    return this.retrieveValue("totalDeaths");
  }

  get bomber() {
    return this.retrieveValue("bombsPlanted");
  }

  get defuser() {
    return this.retrieveValue("bombsDefused");
  }

  get exterminator() {
    return this.retrieveValue("killsConfirmed");
  }

  get medic() {
    return this.retrieveValue("killsDenied");
  }

  get rifleKiller() {
    return this.retrieveValue("rifleKills");
  }

  get smgKiller() {
    return this.retrieveValue("smgKills");
  }

  get sniperKiller() {
    return this.retrieveValue("sniperKills");
  }

  get shotgunKiller() {
    return this.retrieveValue("shotgunKills");
  }

  get teamKiller() {
    return this.retrieveValue("teamKills");
  }

  get teamKilled() {
    return this.retrieveValues("teamKilled");
  }

  get knifeKiller() {
    return this.retrieveValue("meleeKills");
  }

  get knifed() {
    return this.retrieveValues("knifed");
  }

  get headshot() {
    return this.retrieveValue("headshots");
  }

  get headShoted() {
    return this.retrieveValues("headShoted");
  }

  get nadeKiller() {
    return this.retrieveValue("grenadeKills");
  }

  get grenaded() {
    return this.retrieveValues("grenaded");
  }

  get pistolKiller() {
    return this.retrieveValue("pistolKills");
  }

  get consistency() {
    if (this.game) {
      return orderBy(this.playersWithoutSpectators, ["consistency"], ["asc"])[0];
    }
  }

  get inconsistency() {
    if (this.game) {
      return orderBy(this.playersWithoutSpectators, ["consistency"], ["desc"])[0];
    }
  }

  get accuracy() {
    return this.retrieveValue("accuracy");
  }

  get killstreak() {
    return this.retrieveValue("killstreak");
  }

  get deathstreak() {
    return this.retrieveValue("deathstreak");
  }

  get longestKill() {
    return this.retrieveValue("longestKill");
  }

  get longestHS() {
    return this.retrieveValue("longestHS");
  }

  get distance() {
    return this.retrieveValue("distance");
  }

  get camper() {
    if (this.game) {
      return orderBy(this.playersWithoutSpectators, ["distance"], ["asc"])[0];
    }
  }

  get quickestDeath() {
    if (this.game) {
      return orderBy(this.playersWithoutSpectators, ["quickestDeath"], ["asc"])[0];
    }
  }

  get quickestKill() {
    if (this.game) {
      return orderBy(this.playersWithoutSpectators, ["quickestKill"], ["asc"])[0];
    }
  }

  get crazyShooter() {
    return this.retrieveValue("totalShots");
  }

  get everyBulletCounts() {
    if (this.game) {
      return orderBy(this.playersWithoutSpectators, ["totalShots"], ["asc"])[0];
    }
  }

  get collateral() {
    return this.retrieveValue("collateralKills");
  }

  get firstKiller() {
    return this.retrieveValue("firstKiller");
  }

  get firstKilled() {
    return this.retrieveValue("firstKilled");
  }

  get lastKiller() {
    return this.retrieveValue("lastKiller");
  }

  get lastKilled() {
    return this.retrieveValue("lastKilled");
  }

  public game: Game | null = null;
  public winners: Player[] = [];
  public losers: Player[] = [];
  public contender1: string | null = null;
  public contender2: string | null = null;
  public contender1Information: string[] = [];
  public contender2Information: string[] = [];
  public contenderInformation: string[] = [
      "Total Score",
      "Total Kills",
      "Total Deaths",
      "Accuracy",
      "Kill streak",
      "Death streak",
      "Distance",
      "Headshots",
      "Longest Kill",
      "Longest Headshot",
      "Head to Head kills",
  ];
  public winnerPoints: number[] = [];
  public loserPoints: number[] = [];
  protected games!: Game[];
  protected gameResults!: Game[];
  protected scrims!: Game[];

  public created() {
    this.loadData();
  }

  get playersWithoutSpectators(): Player[] {
    if (!this.game) {
      return [];
    }
    return this.game.players.filter((p) => p.totalDeaths > 0);
  }

  @Watch("contender1")
  @Watch("contender2")
  public checkContenders() {
    if (this.game && this.contender1 != null && this.contender2 != null) {
      this.contender1Information = [];
      this.contender2Information = [];
      this.game.players.forEach((_p: Player) => {
        if (_p.playerRef.guid === this.contender1) {
          this.contender1Information.push("" + _p.totalScore);
          this.contender1Information.push("" + _p.totalKills);
          this.contender1Information.push("" + _p.totalDeaths);
          this.contender1Information.push("" + _p.accuracy + "%");
          this.contender1Information.push("" + _p.killstreak);
          this.contender1Information.push("" + _p.deathstreak);
          this.contender1Information.push("" + _p.distance + "m");
          this.contender1Information.push("" + _p.headShots);
          this.contender1Information.push("" + _p.longestKill + "m");
          this.contender1Information.push("" + _p.longestHS + "m");
          this.contender1Information.push("" + (_p.prey[this.contender2!!] || 0));
        }
        if (_p.playerRef.guid === this.contender2) {
          this.contender2Information.push("" + _p.totalScore);
          this.contender2Information.push("" + _p.totalKills);
          this.contender2Information.push("" + _p.totalDeaths);
          this.contender2Information.push("" + _p.accuracy + "%");
          this.contender2Information.push("" + _p.killstreak);
          this.contender2Information.push("" + _p.deathstreak);
          this.contender2Information.push("" + _p.distance + "m");
          this.contender2Information.push("" + _p.headShots);
          this.contender2Information.push("" + _p.longestKill + "m");
          this.contender2Information.push("" + _p.longestHS + "m");
          this.contender2Information.push("" + (_p.prey[this.contender1!!] || 0));
        }
      });
    }
  }

  @Watch("games")
  public loadData() {
    if (this.$route.params.map.indexOf("championship") === 0) {
      const matchId = this.$route.params.map.replace("championship", "");
      this.game = this.gameResults.filter((game) => game.id === matchId)[0];
    } else if (this.$route.params.map.indexOf("scrims") === 0) {
      const matchId = this.$route.params.map.replace("scrims", "");
      this.game = this.scrims.filter((game) => game.id === matchId)[0];
    } else {
      this.game = this.games.filter((game) => game.map === this.$route.params.map)[0];
    }
    if (this.game) {
      const [winnersGuid, losersGuid, winnerPoints, loserPoints] = new GameService().computeWinnersLosers(this.game);
      this.winnerPoints = winnerPoints;
      this.loserPoints = loserPoints;
      this.winners = this.playersWithoutSpectators.filter((p) => winnersGuid.indexOf(p.playerRef.guid) > -1);
      this.losers = this.playersWithoutSpectators.filter((p) => losersGuid.indexOf(p.playerRef.guid) > -1);
    }
  }

  public duration(time: number): string {
    return TimeUtils.getReadableDiffTime(time);
  }

  public formatDate(date: Date): string {
    return !isNaN(date.getDate()) ? format(date, "dd/MM/yyyy") : "";
  }

  public mapNamer(mapName: string): string {
    return mapName.replace("mp_", "").replace(/_/g, " ").toUpperCase();
  }

  public isEfayaMod(game: Game) {
    return game.mod.startsWith("efaya_mod");
  }

  public isEfayaModV2(game: Game) {
    return game.mod.startsWith("efaya_v2");
  }

  public isIMMMod(game: Game) {
    return game.mod.startsWith("imm");
  }

  public isWW2Mod(game: Game) {
    return game.mod.startsWith("ww2");
  }

  public isPromod(game: Game) {
    return game.mod.startsWith("pml");
  }

  private retrieveValue(ref: string) {
    if (this.game) {
      return orderBy(this.playersWithoutSpectators, [ref], ["desc"])[0];
    }
  }

  private retrieveValues(ref: string) {
    if (this.game) {
      const ordered = orderBy(this.playersWithoutSpectators, [ref], ["desc"]);
      // @ts-ignore
      return ordered.filter((v) => v[ref] === ordered[0][ref]);
    }
  }
}
